import { toast } from 'react-toastify';

export const successNotification = (title: string): void => {
  toast.success(title);
};

export const errorNotification = (title: string): void => {
  toast.error(title);
};
